// extracted by mini-css-extract-plugin
export default {"homeTitle":"c-a_fO","homeTitle_styleDefault":"c-a_fP","homeTitle_styleRed":"c-a_fQ"};